import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { initItemsInvoiceParams, NovaPoshtaService } from '../../services/nova-poshta.service';
import { IParams } from '../../model/http';
import { map, Observable, Subject, take, takeUntil } from 'rxjs';
import { AppTableSource, ColumnSortType } from '../../model/table.model';
import { NotificationService } from '../../services/notifications.service';
import { IntegrationService } from '../../services/integration.service';
import { BaseService } from '../../services/base.service';
import { tableHeaders } from './tab-templates.interface';
import { MatDialog } from '@angular/material/dialog';
import { CreateTemplateComponent } from '../../components/modals/create-template/create-template.component';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-tab-templates',
  templateUrl: './tab-templates.component.html',
  styleUrls: ['./tab-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabTemplatesComponent implements OnInit, OnDestroy {
  private readonly destroy$: Subject<null> = new Subject<null>();

  @Input() apiKey!: any;

  dataSource$: Observable<AppTableSource> = this.novaPoshtaService.itemsInvoices$.pipe(
    map((data) => {
      tableHeaders.map((column) => {
        column.sort = ColumnSortType.NONE;
        if (column.value === this.dataSort?.active) {
          column.sort = this.dataSort.direction;
        }
        return column;
      });
      return {
        headers: tableHeaders,
        rows: data.items,
        pageSize: localStorage?.getItem('channelTake') || data?.size || 0,
        pageIndex: data.page ? data.page - 1 : 0,
        length: data.total || 0,
      };
    }),
  );
  visibleColumns = tableHeaders.map((v) => v.value);

  // Variables

  private itemsRequest: any;
  private dataSort: any;
  public isLoader: boolean = false;
  private timerSearch: any;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly integrationService: IntegrationService,
    private readonly novaPoshtaService: NovaPoshtaService,
    public readonly baseService: BaseService,
    public readonly dialog: MatDialog,
    public readonly modalService: ModalService,
  ) {}

  getItemsWithUpdatedParams(params: IParams, isLoader = false) {
    if (this.itemsRequest) {
      this.itemsRequest.unsubscribe();
    }
    this.isLoader = isLoader;
    this.itemsRequest = this.novaPoshtaService
      .setQueryListInvoicesParams(params)
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: (res) => {
          this.isLoader = false;
        },
        error: () => {
          this.isLoader = false;
        },
      });
  }

  ngOnInit() {
    this.isLoader = true;
    this.novaPoshtaService
      .loadListInvoices()
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe({
        next: () => {
          this.isLoader = false;
        },
        error: () => {
          this.isLoader = false;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onSortChange(sortState: any) {
    this.dataSort = sortState;
    this.getItemsWithUpdatedParams({
      sort: sortState.active,
      order: sortState.direction,
    });
  }

  onPaginationChange(paginationDetails: any) {
    const { pageIndex, pageSize } = paginationDetails;
    localStorage.removeItem('invoiceTake');
    localStorage.setItem('invoiceTake', pageSize);
    this.novaPoshtaService.updateInvoiceTake();
    const page = pageIndex + 1;
    const take = pageSize;
    this.getItemsWithUpdatedParams({ page, take }, true);
  }

  onActionChange(event: any) {
    if (event.label === 'DELETE') {
      this.novaPoshtaService
        .deleteInvoice(event.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.getItemsWithUpdatedParams({
              ...initItemsInvoiceParams,
            });
          },
        });
    }
  }

  onSearchChange(search: string) {
    if (this.timerSearch) clearTimeout(this.timerSearch);
    this.timerSearch = setTimeout(() => {
      this.getItemsWithUpdatedParams(
        {
          ...initItemsInvoiceParams,
          search,
        },
        true,
      );
    }, 500);
  }

  onAdd() {
    const modalData = {
      title: 'create_template',
      translate: true,
      component: CreateTemplateComponent,
      width: '60vw',
      data: {
        api_key: this.apiKey,
      },
    };

    this.modalService.openModal(modalData).pipe(takeUntil(this.destroy$)).subscribe();
  }
}
